<script>
	import { onDestroy } from "svelte";
	import { createEventDispatcher } from "svelte";

	export let value = "text";

	const dispatch = createEventDispatcher();

	let name = "";
	let charAt = 0;
	let characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	let charsArr = [];

	String.prototype.replaceAt = function (index, replacement) {
		return (
			this.substr(0, index) +
			replacement +
			this.substr(index + replacement.length)
		);
	};

	const interval = setInterval(() => {
		if (name === value) {
			clearInterval(interval);
			dispatch("terminate", {
				value: value,
			});
		}

		if (charsArr[charAt] == undefined) {
			charsArr[charAt] = characters;
		}

		if (!charsArr[charAt].length) {
			name = value;
		}

		if (name.charAt(charAt) !== value.charAt(charAt)) {
			let randChar = charsArr[charAt].charAt(
				Math.floor(Math.random() * charsArr[charAt].length)
			);
			charsArr[charAt] = charsArr[charAt].replace(randChar, "");
			name = name.replaceAt(charAt, randChar);
		}
		charAt = charAt < value.length ? charAt + 1 : 0;
	}, 2);

	onDestroy(() => clearInterval(interval));
</script>

<span translate="no">{name}</span>
